import { render, staticRenderFns } from "./PublicIpResource.vue?vue&type=template&id=15384a34&"
import script from "./PublicIpResource.vue?vue&type=script&lang=js&"
export * from "./PublicIpResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports